import React from "react";
import MasterTemplate from "./MasterTemplate";
import Cartela from '../_Components/Cartela';
import loading from '../Assets/images/loading.gif';
import { Link } from 'react-router-dom';
import API from '../Utils/api'

export class Sorteio extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            sorteioStatus: false,
            isLoading: false,
            isBlockPanel: false,
            listaDeGabaritos: [],
            numeros: [],
            tipoPremio: 'NENHUM',
            imagens: {
                premioKuadraA: null, 
                premioKuadraB: null, 
                premioKinaA: null,
                premioKinaB: null,
                premioCruzA: null,
                premioCruzB: null,
                premioCheiaA: null,
                premioCheiaB: null
            },
            score : {premiado : 0, faltam1 : 0, faltam2: 0, faltam3: 0, cartelasDaFina: [], cartelasPremiadas: []}
        }


        this.getGabaritosAtivos();
        this.getSorteioStatus();
        this.obterNumerosDoSorteio();
        this.getTipoBatida();
        this.getPremioImagens();
    }

    iniciarSorteio = async () => {
        try {
            this.updateTipoBatida("NENHUM");
            await API.get("/api/gabaritos/desativar-gabaritos");
            await API.post("/api/parametros/bloquea-venda", {});
            await API.post("/api/historicos/fechar-ultimo-historico", {});
            await API.post("/api/gabaritos/renova-vencedores", {});
            await API.post("/api/parametros/atualizar-sorteio-status", {sorteioStatus : true});
            this.setState({sorteioStatus : true});
        } catch (error) {
            console.log(error);
        }
    }

    fecharSorteioStatus = async () => {
        try {
            await API.post("/api/parametros/atualizar-sorteio-status", {sorteioStatus : false});
            this.setState({sorteioStatus : false});
        } catch (error) {
            console.log(error);
        }
    }

    getSorteioStatus = async () => {
        try {
            const response = await API.get("/api/parametros/obter-sorteio-status");
            this.setState({sorteioStatus : response.data.sorteioStatus});
        } catch (error) {
            console.log(error);
        }
    }

    getPremioImagens= async () => {
        try {
            const response = await API.get("/api/parametros/premio-imagens");
            this.setState({imagens: response.data});
        } catch (error) {
            console.log(error);
        }
    }

    finalizarSorteio() {
        this.resetarNumeros();
        this.fecharSorteioStatus();
        alert("Sorteio finalizado com sucesso!");
        window.location.reload();
    }


    resetarNumeros = async () => {
        try {
            await API.post("/api/parametros/alterar-numeros-sorteados", { numeros: [] });
        } catch (err) {
            console.log(err);
        }
    }

    obterNumerosDoSorteio = async () => {
        try {
           const response = await API.get("/api/parametros/obter-numeros-sorteados");
           this.setState({numeros : response.data})
           this.updateNumeros(null)
        } catch (err) {
            console.log(err);
        }
    }

    updateTipoBatida = async (tipoBatida) => {
        try {
           const response = await API.post("/api/parametros/atualizar-batida",{tipoBatida : tipoBatida});
        } catch (err) {
            console.log(err);
        }
    }


    getTipoBatida = async () => {
        try {
           const response = await API.get("/api/parametros/get-tipobatida");
           this.setState({tipoPremio : response.data.tipoBatida})
        } catch (err) {
            console.log(err);
        }
    }

    getGabaritosAtivos = async () => {
        try {
            const response = await API.get("/api/gabaritos/gabaritos-ativos", {});
            this.setState({ listaDeGabaritos: response.data })
        } catch (err) {
            console.log(err);
        }
    }

    setColorCell(value) {
        if (this.state.numeros.includes(parseInt(value)))
            return "btn-fill btn-danger"
        else {
            return "btn-fill btn-dark"
        }
    }

    updateNumeros = async (e) => {
        if(this.state.tipoPremio && this.state.tipoPremio != "NENHUM"){
        if(e){
            if(this.state.numeros.includes(parseInt(e.target.value))){
                this.state.numeros.splice(this.state.numeros.indexOf(parseInt(e.target.value)),1);
                this.setState({numeros: this.state.numeros });
            }
            else{
                this.state.numeros.push(parseInt(e.target.value))
                this.setState({numeros: this.state.numeros});
            } 
            this.setState({isBlockPanel : true, numeros: this.state.numeros});
        }
            try {
                e? await API.post("/api/parametros/alterar-numeros-sorteados", { numeros: this.state.numeros}) : console.log('sem numeros');
                const response = await API.get(`/api/pedidos/${this.state.tipoPremio}/${this.state.numeros.join()}`);
                this.setState({isBlockPanel : false, score : response.data});
            } catch (err) {
                console.log(err);
            }
    }
    }


    PainelDeNumeros = () => {
        const rows = []
        const cols = []
        for (var i = 0; i < 5; i++)
            rows.push(i)
        for (var i = 0; i < 15; i++)
            cols.push(i)
        return (
            <div className="mt-3 container overflow-auto painel">
                {rows.map((row, rowIndex) =>
                    <div className="row">
                        {cols.map((col, colIndex) =>
                            <div className="col">
                                <button style={{cursor: 'pointer'}} disabled={this.state.isBlockPanel} className={this.state.isBlockPanel ? 'btn-fill btn btn-secondary bg-secondary' : this.setColorCell((rowIndex * 15 + (colIndex + 1)))} onClick={this.updateNumeros.bind(this)} value={rowIndex * 15 + (colIndex + 1)} >{rowIndex * 15 + (colIndex + 1)}</button>
                            </div>)}
                    </div>)}
            </div>
        )
    }

    handleTipoBatida(e){
        this.state.tipoPremio = e.target.value;
        this.setState({tipoPremio: e.target.value});
        this.updateTipoBatida(e.target.value);
        //localStorage.setItem("tipoPremio", e.target.value);
        this.setState({score : {premiado : 0, faltam1 : 0, faltam2: 0, faltam3: 0, cartelasDaFina: [],  cartelasPremiadas: []}});

        this.getGabaritosAtivos();
        this.updateNumeros(null);
    }

    render() {
        const PainelDeNumeros = this.PainelDeNumeros;
            return( 
            <div style={{flex: 1, width: "100%", height: '100%'}}>
             {this.state.isLoading? 
                 <div className='sf-modal'>
                    <img className='sf-loading' src={loading}></img>
                </div> : ""}
             <MasterTemplate label={"Show de Prêmios!"}>
                <div className="modal w-50" id="exampleModal2" style={{ marginLeft: '20em' }} tabindex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Alerta</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>Confirmar inicio do sorteio.!</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn-fill btn btn-secondary" data-dismiss="modal">Cancelar</button>
                                <button type="button" data-dismiss="modal"  className="btn-fill btn btn-primary" onClick={this.iniciarSorteio.bind(this)}>Iniciar sorteio</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal" id="exampleModal3" style={{ marginLeft: '0em' }} tabindex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Cartelas armadas!!</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body d-flex " style={{ overflowX: "scroll" }}>
                                {1 != undefined && 1 > 0 ?
                                    [].map(cartela => {
                                        return <Cartela className="ml-3" cartela={cartela}></Cartela>
                                    })

                                    : ""}

                            </div>
                        </div>
                    </div>
                </div>


                <div className="container bg-white" >
                    <div className="row border" style={{ minHeight: '25em' }} >
                        <div className="col border" style={{ maxWidth: '15em' }} >
                            <div className="row d-block" style={{ minHeight: '3em', margin: '0' }}>
                                <div className="row justify-content-center" >
                                    <span className="text-dark font-weight-bold ">Data da extração: </span>
                                </div>
                                <div className="row  justify-content-center" >
                                    <span className="text-dark font-weight-bold"></span>
                                </div>
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', width: '100%', minHeight: '17em', maxHeight: '17em', margin: '0', overflow: 'auto', justifyContent: 'center', alignItems: 'center' }}>
                                   {this.state.tipoPremio === "kuadra" && this.state.score.premiado > 0?
                                        <img width="180" height="180" src={this.state.imagens.premioKuadraB}></img>           
                                    : this.state.tipoPremio === "kuadra"?
                                        <img width="180" height="180"  src={this.state.imagens.premioKuadraA}></img>   
                                        :<></>
                                   } 

                                    {this.state.tipoPremio === "kina" && this.state.score.premiado > 0?
                                        <img width="180" height="180" src={this.state.imagens.premioKinaB}></img>           
                                    : this.state.tipoPremio === "kina"?
                                        <img width="180" height="180" src={this.state.imagens.premioKinaA}></img>   
                                        :<></>
                                    } 

                                    {this.state.tipoPremio === "cruzadinha" && this.state.score.premiado > 0?
                                        <img width="180" height="180" src={this.state.imagens.premioCruzB}></img>           
                                    :  this.state.tipoPremio === "cruzadinha"?
                                        <img width="180" height="180" src={this.state.imagens.premioCruzA}></img>   
                                        :<></>
                                    }

                                    {this.state.tipoPremio === "cheia" && this.state.score.premiado > 0?
                                        <img width="180" height="180" src={this.state.imagens.premioCheiaB}></img>           
                                    : this.state.tipoPremio === "cheia"?
                                        <img width="180" height="180" src={this.state.imagens.premioCheiaA}></img>   
                                        :<></>
                                    }
                            </div>
                            <div className={this.state.sorteioStatus? "row border d-block" : "d-none"} style={{ minHeight: '5em' }}>
                                <div className={this.state.score.premiado > 0 ? "row m-0" : "collapse"}>
                                    <div className="col p-0">
                                        <span className="font-weight-bold" style={{ fontSize: '0.7em' }} >Temos {this.state.score.premiado > 1? `${this.state.score.premiado} cartelas premiadas!!` : `apenas 1 cartela premiada!!`}</span>
                                    </div>
                                </div>
                                <div className={this.state.score.faltam1 > 0 ? "row m-0 p-0" : "collapse"}>
                                    <div className="col p-0">

                                        <span data-toggle="modal" data-dismiss="modal" data-target="#exampleModal3" id="modal3" style={{ fontSize: '0.7em' }} >Total de {this.state.score.faltam1} cartelas faltando um numero!</span>
                                    </div>
                                </div>
                                <div className={this.state.score.faltam2 > 0 ? "row m-0 p-0" : "collapse"}>
                                    <div className="col p-0">
                                        <span style={{ fontSize: '0.7em' }}>Total de {this.state.score.faltam2} cartelas faltando dois numeros!</span>
                                    </div>
                                </div>
                                <div className={this.state.score.faltam3 > 0 ? "row m-0 p-0" : "collapse"}>
                                    <div className="col p-0">
                                        {/* <span style={{ fontSize: '0.7em' }}>Total de {this.state.score.faltam3} cartelas faltando três numeros</span> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col border" style={{ maxWidth: '15em', overflow: 'scroll', maxHeight: '23rem' }} >
                            <div className="row d-flex justify-content-center text-center">
                                <span className="font-weight-bold">Cartelas concorrendo</span>
                            </div>
                            <hr/>
                            {this.state.score.cartelasPremiadas.map(cartela => 
                                <>
                                <div className="mt-1 d-flex justify-content-center text-center">
                                    <span style={{fontSize: 22, fontWeight: 'bold'}} >{cartela[1].codigo}</span>
                                </div>
                                </>
                            )}
                            <hr></hr>
                            {this.state.score.cartelasDaFina.map(cartela => 
                                <>
                                <div className="mt-1 d-flex justify-content-center text-center">
                                    <span style={{fontSize: 18}} >{cartela[1].codigo}</span>
                                </div>
                                </>
                            )}
                            
                        </div>
                        <div className="col border" >
                            <div className="row">
                                <div style={{display: 'flex' , flexDirection: 'column', maxWidth: '128px !important'}}>
                                
                                    <button disabled={this.state.sorteioStatus} className={!this.state.sorteioStatus ? "ml-3 mt-3 mb-3 btn-fill btn btn-primary" : "collapse"} data-toggle="modal" data-dismiss="modal" data-target="#exampleModal2" >Iniciar Sorteio</button>

                                    <button className={this.state.sorteioStatus ? "ml-3 mt-3 btn-fill btn btn-danger" : "collapse"} onClick={this.finalizarSorteio.bind(this)}>Finalizar Sorteio</button>
                                    <select defaultValue={this.state.tipoPremio} onChange={this.handleTipoBatida.bind(this)} className={this.state.sorteioStatus ? "ml-3 mt-3 custom-select" : "collapse"}>
                                        <option value={'NENHUM'} >Nenhum</option>
                                        <option value={'kuadra'} >Kuadra</option>
                                        <option value={'kina'}>Kina</option>
                                        <option value={'cruzadinha'}>Cruzadinha</option>
                                        <option value={'cheia'}>Cheia</option>
                                        <option value={'fina'}>Fina</option>
                                    </select>
                                </div>
                                <div className="col pl-5">
                                    <Link className="ml-5"></Link>
                                    <Link className="ml-5"></Link>
                                    <Link className="ml-5"></Link>
                                    <Link className={this.state.sorteioStatus ? "ml-5 mt-3 btn-fill btn btn-warning text-light" : "collapse"} to="/sorteio-giro">Sortear Giro</Link>
                                </div>
                            </div>
                            {this.state.sorteioStatus && this.state.tipoPremio != "NENHUM" ? <PainelDeNumeros /> : ''}
                            <div className="mt-5 justify-content-center row">
                                <button className={0 === 1 && 0 === "true" && 0 ? "btn-fill btn btn-warning" : "collapse"}  >Registrar Kuadra</button>
                                <button className={0 === 4 && 0 === "true" && 0 ? "btn-fill btn btn-info" : "collapse"}  >Registrar Finas</button>

                            </div>

                        </div>

                    </div>

   
                    

                    <div className="row border d-block" style={{ minHeight: '5em' }}>
                        <div className="row" style={{ margin: '0' }}>
                            <span className="text-dark font-weight-bold"> Total de numeros: </span><span className="ml-3 text-danger">{this.state.numeros.length}</span>
                        </div>

                        <div className="row d-inline" style={{ margin: '0' }}>
                            <div className="row pr-5 pl-5">
                                {this.state.numeros.map(numero => {
                                    return <div className="mt-1 bola-bingo"><span >{numero < 10 ? '0'+ numero : numero}</span></div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
            </div>
            )
    }
}

export default Sorteio;
